import { IonSkeletonText, useIonModal } from "@ionic/react";
import { modalController } from "@ionic/core";
import { useRfidProfileQuery } from "../query/rfidProfileQuery";
import RfidProfileModal from "../modals/RfidProfileModal";
import styles from "./TaggedCatName.module.css";
import { getRfidDisplayLabel } from "../utils/rfidDisplay";

interface TaggedCatNameProps {
    rfidCode: string,
    deviceId?: string
}

const TaggedCatName: React.FC<TaggedCatNameProps> = ({ rfidCode, deviceId }) => {
    const query = useRfidProfileQuery(rfidCode, deviceId);
    const [presentProfile, dismissProfile] = useIonModal(RfidProfileModal, {
        dismiss: (data: string, role: string) => dismissProfile(data, role),
        rfidCode
    });

    const openProfile = (e: any) => {
        (async () => {
            presentProfile({
                presentingElement: await modalController.getTop() || document.getElementsByTagName('ion-router-outlet')[0]
            });
        })();

        e.stopPropagation();
        e.preventDefault();
        return false;
    };

    return (
        <button type="button" className={styles.taggedCatName} onClick={openProfile}>
            {query.isLoading
                ? <IonSkeletonText className={styles.taggedCatNameSkeleton} animated />
                : getRfidDisplayLabel(rfidCode, query.data?.label)}
        </button>
    );
};

export default TaggedCatName;
